export default __webpack_public_path__ + "static/media/landing5.fea70c31.jpeg";